import { Link } from 'react-router-dom';

const Footer = () => {
  const handleCatalogSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email');
    alert(`Katalog ${email} adresine gönderilecek!`);
    e.currentTarget.reset();
  };

  return (
    <footer className="bg-sage py-16 mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div className="md:col-span-1">
            <h3 className="text-3xl font-display font-semibold text-navy mb-4">
              Katalog İsteyin
            </h3>
            <p className="text-sm text-warmGray mb-6">
              Ürün kataloğumuzu e-posta adresinize gönderelim
            </p>
            <form onSubmit={handleCatalogSubmit} className="flex gap-3">
              <input
                type="email"
                name="email"
                placeholder="E-posta adresiniz"
                required
                className="flex-1 px-4 py-3 rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-coral"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-navy text-white rounded-full text-sm font-medium hover:bg-navy/90 transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer"
              >
                Gönder
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-navy mb-4">Hızlı Linkler</h4>
            <div className="flex flex-col gap-3">
              <Link to="/hakkimizda" className="text-sm text-warmGray hover:text-coral transition-colors">
                Hakkımızda
              </Link>
              <Link to="/urunler" className="text-sm text-warmGray hover:text-coral transition-colors">
                Ürünler
              </Link>
              <Link to="/projeler" className="text-sm text-warmGray hover:text-coral transition-colors">
                Projeler
              </Link>
              <Link to="/iletisim" className="text-sm text-warmGray hover:text-coral transition-colors">
                İletişim
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-navy mb-4">İletişim</h4>
            <div className="flex flex-col gap-3 text-sm text-warmGray">
              <a href="tel:+902165190313" className="hover:text-coral transition-colors flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                0216 519 03 13
              </a>
              <a href="mailto:info@atolyemini.com" className="hover:text-coral transition-colors flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                info@atolyemini.com
              </a>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base mt-0.5 flex-shrink-0"></i>
                <p className="leading-relaxed">
                  Finanskent Mah. Finans Cad.<br />
                  Sarphan Finanspark Blok B2 Ofis 387<br />
                  Ataşehir / İstanbul
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-navy/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center text-navy hover:text-coral transition-colors cursor-pointer">
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-navy hover:text-coral transition-colors cursor-pointer">
              <i className="ri-facebook-circle-line text-xl"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-navy hover:text-coral transition-colors cursor-pointer">
              <i className="ri-linkedin-box-line text-xl"></i>
            </a>
          </div>

          <p className="text-sm text-warmGray">© 2025 Atölyemini. Tüm hakları saklıdır.</p>

          <div className="flex gap-6">
            <a href="#" className="text-sm text-warmGray hover:text-coral transition-colors">
              Gizlilik Politikası
            </a>
            <a href="#" className="text-sm text-warmGray hover:text-coral transition-colors">
              Kullanım Şartları
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;